
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

// Lazy load components
const Home = lazy(() => import('../pages/home/page'));
const Monitor = lazy(() => import('../pages/monitor/page'));
const MonitorFlow = lazy(() => import('../pages/monitor-flow/page'));
const ProductTypes = lazy(() => import('../pages/product-types/page'));
const WhyFree = lazy(() => import('../pages/why-free/page'));
const Thanks = lazy(() => import('../pages/thanks/page'));
const Terms = lazy(() => import('../pages/terms/page'));
const Privacy = lazy(() => import('../pages/privacy/page'));
const CommerceLaw = lazy(() => import('../pages/commerce-law/page'));
const GoForm = lazy(() => import('../pages/go-form/page'));
const FAQ = lazy(() => import('../pages/faq/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/monitor',
    element: <Monitor />
  },
  {
    path: '/monitor-flow',
    element: <MonitorFlow />
  },
  {
    path: '/product-types',
    element: <ProductTypes />
  },
  {
    path: '/why-free',
    element: <WhyFree />
  },
  {
    path: '/thanks',
    element: <Thanks />
  },
  {
    path: '/terms',
    element: <Terms />
  },
  {
    path: '/privacy',
    element: <Privacy />
  },
  {
    path: '/commerce-law',
    element: <CommerceLaw />
  },
  {
    path: '/go-form',
    element: <GoForm />
  },
  {
    path: '/faq',
    element: <FAQ />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
